import type { AppIconInput } from "./appIcon";
import { resolveFriendlyAppNameDisplay } from "./resolveFriendlyAppNameDisplay";
import type { FriendlyAppNameInput } from "./friendlyAppName";
import { useAppStoreMetadata } from "./useAppStoreMetadata";

/**
 * Component-side friendly name resolver with cache-first App Store naming.
 * Resolution order: cached App Store trackName -> existing friendlyAppName
 * heuristics. Use at render call sites where a hook is allowed; non-component
 * code keeps calling the synchronous `friendlyAppName`.
 */
export function useFriendlyAppName(input: FriendlyAppNameInput & AppIconInput): string {
  const { metadata, resolveFailed, isOnline } = useAppStoreMetadata(input);
  return resolveFriendlyAppNameDisplay(input, metadata, { isOnline, resolveFailed });
}
